// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + {"149": "ee1defb0","175": "74d5289a","186": "dcee2fd8","409": "6bcbe5e2","453": "078f9325","931": "21c0be10",}[chunkId] + ".chunk.js"
}